import PropTypes from 'prop-types';
import React, { Component } from 'react';
import TextFieldMUI from 'material-ui/TextField';
import _ from 'lodash';
import styles from './TextFieldStyles';
import { KEYS } from 'crazyEditor/core/constants/editorConstants';

export default class TextField extends Component {

  constructor(props) {
    super(props);

    const initialValue = props.value ? props.value : null;
    this.onChange = this.onChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.state = {
      value: initialValue
    };
  }

  componentDidMount() {
    this.refs.textFieldMUI.select();
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEmpty(nextProps.errorText) && typeof this.refs.textFieldMUI._getInputNode === 'function') {
      this.refs.textFieldMUI._getInputNode().select();
    }
  }

  onChange(event) {
    const newValue = event.target.value;
    this.setState({
      value: newValue
    });
  }

  onKeyDown(event) {
    if (event.keyCode === KEYS.ENTER) {
      this.triggerParentOnChange();
    } else if (event.keyCode === KEYS.ESC) {
      this.setState({
        value: this.props.value
      });
      if (typeof this.refs.textFieldMUI._getInputNode === 'function') {
        this.refs.textFieldMUI._getInputNode().select();
      }
    }
    if (this.props.onKeyDown) {
      this.props.onKeyDown(event);
    }
  }

  getValue() {
    return this.refs.textFieldMUI.getValue();
  }

  triggerParentOnChange() {
    if (this.props.onChange) {
      this.props.onChange(this.state.value);
    }
  }

  render() {
    const filteredProps = _.omit(this.props, ['value', 'onChange', 'onKeyDown']);
    return (
      <TextFieldMUI
        ref="textFieldMUI"
        value={this.state.value}
        onChange={this.onChange}
        onKeyDown={this.onKeyDown}
        underlineFocusStyle={_.assign({}, styles.underlineFocusStyle, this.props.underlineFocusStyle)}
        spellCheck={false}
        {...filteredProps}
      />
    );
  }
}

TextField.propTypes = {
  value: PropTypes.string
};